import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../button/button/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSSecondaryButton } from '../../button/secondary-button/index.esm.js';
import '../../button/paging-button/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import styles from '../../styles/uitk-egds-input.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useIdCompatibility } from '../../utils/use-id-compatibility/index.esm.js';
import { liveAnnounce } from '../../utils/live-announce/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSInputSwapper = props => {
  const {
    startInput,
    endInput,
    onSwapButtonClick,
    isHorizontalSwapper = true,
    a11ySwapButtonLabel,
    id,
    onSwapClickAnnounceText
  } = props;
  const uId = useIdCompatibility();
  const {
    formatText
  } = useLocalization();
  const {
    label: startInputLabel,
    value: startInputValue
  } = startInput.props;
  const {
    label: endInputLabel,
    value: endInputValue
  } = endInput.props;
  const [toggleRotateClassName, setToggleRotateClassName] = React.useState('');
  const [toggle, setToggle] = React.useState(true);
  const buttonRef = React.useRef(null);
  const baseClassName = 'uitk-input-swapper';
  const wrapperClassnames = getClassNameList(baseClassName, `${baseClassName}-horizlayout-${isHorizontalSwapper}`);
  const toggleClassnames = getClassNameList(`${baseClassName}-toggle`, toggleRotateClassName);
  const toggleIconClassnames = getClassNameList(`${baseClassName}-toggle-icon`);
  const startInputClassnames = getClassNameList(`${baseClassName}-start-input`);
  const endInputClassnames = getClassNameList(`${baseClassName}-end-input`);
  const swapButtonAction = formatText('input.swapper.action', startInputLabel, endInputValue, endInputLabel, startInputValue);
  const swapButtonInstructions = formatText('input.swapper.instructions', startInputLabel, endInputLabel);
  const swapInputFields = () => {
    setToggle(prevState => {
      if (toggle) {
        setToggleRotateClassName(`${baseClassName}-toggle-rotate-forwards`);
      } else {
        setToggleRotateClassName(`${baseClassName}-toggle-rotate-backwards`);
      }
      liveAnnounce(`${onSwapClickAnnounceText ?? swapButtonAction}`);
      return !prevState;
    });
    if (onSwapButtonClick) {
      onSwapButtonClick();
    }
  };
  return jsxs("div", {
    className: wrapperClassnames,
    children: [jsx("div", {
      className: startInputClassnames,
      children: startInput
    }), jsx(EGDSSecondaryButton, {
      onClick: swapInputFields,
      "aria-label": a11ySwapButtonLabel ?? swapButtonInstructions,
      className: toggleClassnames,
      domRef: buttonRef,
      children: jsx(EGDSIcon, {
        className: toggleIconClassnames,
        name: "swap_vert",
        title: a11ySwapButtonLabel ?? swapButtonInstructions,
        id: `swap-horizontal-icon-${id ?? uId}`
      })
    }), jsx("div", {
      className: endInputClassnames,
      children: endInput
    })]
  });
};
export { EGDSInputSwapper };